"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("../../components/Accordion");
Accordion_1.Accordion.each('[data-accordion-tab]');
